import Grid from "@mui/material/Grid";

import laserCutting from "../../assets/img/machines/laser_cutting.webp";
import bendingMachine from "../../assets/img/machines/bending_machine.webp";
import shearingMachine from "../../assets/img/machines/shearing_machine.webp";

const MachineDetails = () => {
  return (
    <div className="app-machineDetails" id="machine-details">
      <h2 className="app-machineDetails__headText">
        Machine's equiped in our infrastructure
      </h2>
      <Grid
        container
        direction="row"
        alignItems="stretch"
        className="app-machineDetails__gridContainer"
      >
        <Grid item xs={12} md={4} className="app-machineDetails__grid">
          <div className="img-hover-zoom">
            <img
              className="machineDetails__gridImage"
              src={laserCutting}
              alt="Laser Cutting"
            />
          </div>
          <h4 className="machineDetails-gridHeadText">Laser Cutting</h4>
          <ul>
            <li>
              <span className="machineDetails-desc-label">Material:&nbsp;</span>
              Mild Steel(MS) & Stainless Steel(SS)
            </li>
            <li>
              <span className="machineDetails-desc-label">
                MS Cutting Thickness:&nbsp;
              </span>
              0.5mm to 18mm
            </li>
            <li>
              <span className="machineDetails-desc-label">
                SS Cutting Thickness:&nbsp;
              </span>
              0.5mm to 8mm
            </li>
            <li>
              <span className="machineDetails-desc-label">Bed Size:&nbsp;</span>
              10 x 5 ft
            </li>
          </ul>
        </Grid>
        <Grid item xs={12} md={4} className="app-machineDetails__grid">
          <div className="img-hover-zoom">
            <img
              className="machineDetails__gridImage"
              src={bendingMachine}
              alt="CNC Bending"
            />
          </div>
          <h4 className="machineDetails-gridHeadText">CNC Bending</h4>
          <ul>
            <li>
              <span className="machineDetails-desc-label">Material:&nbsp;</span>
              Mild Steel(MS)
            </li>
            <li>
              <span className="machineDetails-desc-label">
                Control Type:&nbsp;
              </span>
              CNC
            </li>
            <li>
              <span className="machineDetails-desc-label">
                Max Sheet Length:&nbsp;
              </span>
              10ft
            </li>
            <li>
              <span className="machineDetails-desc-label">
                Bending Capacity:&nbsp;
              </span>
              4mm
            </li>
          </ul>
        </Grid>
        <Grid item xs={12} md={4} className="app-machineDetails__grid">
          <div className="img-hover-zoom">
            <img
              className="machineDetails__gridImage"
              src={shearingMachine}
              alt="Shearing Machine"
            />
          </div>
          <h4 className="machineDetails-gridHeadText">Shearing</h4>
          <ul>
            <li>
              <span className="machineDetails-desc-label">Material:&nbsp;</span>
              Mild Steel(MS) & Stainless Steel(SS)
            </li>
            <li>
              <span className="machineDetails-desc-label">
                MS Cutting Thickness:&nbsp;
              </span>
              4mm
            </li>
            <li>
              <span className="machineDetails-desc-label">
                SS Cutting Thickness:&nbsp;
              </span>
              3mm
            </li>
            <li>
              <span className="machineDetails-desc-label">
                Max Sheet Length:&nbsp;
              </span>
              8ft
            </li>
          </ul>
        </Grid>
      </Grid>
    </div>
  );
};

export default MachineDetails;
